export default function AppSection() {
  return (
    <section id="app" className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-background-900 to-background-800 p-8 md:p-12">
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-0 right-0 w-80 h-80 bg-primary-500 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
              <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-500 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>
            </div>

            <div className="relative z-10 flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 text-center lg:text-left">
                <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs font-semibold mb-4">
                  移动吃瓜
                </span>
                <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-4">
                  随时随地吃瓜
                </h2>
                <p className="text-foreground-400 text-sm leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
                  吃瓜网每日大赛移动端完美适配，上班摸鱼、通勤路上、睡前刷一刷，
                  最新明星大瓜与娱乐圈内幕随时随地想看就看。无需下载安装，浏览器打开即可畅享完整吃瓜体验。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 text-white text-sm cursor-pointer hover:bg-white/20 transition-colors">
                    <i className="ri-android-line"></i>
                    <span>安卓版吃瓜</span>
                  </div>
                  <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white/10 text-white text-sm cursor-pointer hover:bg-white/20 transition-colors">
                    <i className="ri-apple-line"></i>
                    <span>iOS版吃瓜</span>
                  </div>
                  <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-semibold cursor-pointer hover:bg-primary-600 transition-colors">
                    <i className="ri-qr-scan-line"></i>
                    <span>扫码直达</span>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="absolute inset-0 bg-primary-500/20 rounded-3xl blur-2xl"></div>
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20entertainment%20news%20app%20interface%20with%20bold%20headlines%20and%20vibrant%20red%20accent%20colors%2C%20modern%20mobile%20UI%20design%2C%20dark%20mode%20theme%2C%20clean%20typography%2C%20minimalist%20phone%20frame%2C%20floating%20on%20gradient%20background%2C%20product%20photography%20style&width=600&height=800&seq=app-chigua&orientation=portrait"
                    alt="吃瓜网每日大赛 - 移动端体验"
                    className="relative z-10 w-48 md:w-56 h-auto rounded-3xl shadow-2xl"
                    loading="lazy"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}